export enum MessageType {
  DOWNLOAD_TAX_REPORT = "download-tax-report",
  POSITION = "position",
  TAX_LOSS_HARVESTING = "tax-loss-harvesting",
}
